
<template>
  <div>
    <!--如果注册成功-->
    <div class="success_wrap">
      <img src="@/assets/img/icon_success.png" />
      <div class="success_text">
        <div class="text1">已提交{{ flowName }}，请等待审核</div>
        <span class="text2">温馨提示：申请审核进度，请前往<label style="font-weight: bold">【首页-登录账号】</label>查看</span>
      </div>
    </div>
    <div class="btn_1 btn_custom1" @click.stop="$router.push('/')">返回首页</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      flowName: this.$route.query.name
    }
  }
}
</script>
<style lang="scss" scoped>
.success_wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 150px;
  .success_text {
    margin-left: 10px;
    .text1 {
      color: #0774d7;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 11px;
    }
    .text2 {
      color: #666;
    }
  }
}
.btn_custom1 {
  font-weight: bold;
  position: relative;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  margin: 100px 0 100px;
  width: 160px;
}
</style>